import React, { useMemo, useCallback } from "react";
import Avatar from "../../../../../components/Avatar";
import { Grid, Tooltip } from "@mui/material";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useCustomSearchParams } from "../../../../../hooks/useCustomSearchParams";
import { createAvtarName, hasImage } from "../../../../../utils";
import { useResponsive } from "../../../../../hooks/useResponsive";
import arrow from "../../../../../styles/svg/arrow.svg"
import { formateDateMMDDYY } from "../../../../../utils/helpers";
import { useSearchParams } from "react-router-dom";
function CustomFields({ history, boardName, isDueDate = false, hideDetails = false }) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const boardKey = boardName?.data?.data?.responseData?.key;
  const [data, updateSearchParams] = useCustomSearchParams("card_id");
  const isMobile = useResponsive("down", "md");

  const userData = useMemo(() => ({
    username: history?.response_object?.user_object?.username || '',
    userImage: history?.response_object?.user_object?.user_image,
    profileColor: history?.response_object?.user_object?.user_profile_color,
  }), [history?.response_object?.user_object]);

  const boardData = useMemo(() => ({
    boardId: boardName?.data?.data?.responseData?.board_id,
    boardKey: boardName?.data?.data?.responseData?.key,
    boardName: boardName?.data?.data?.responseData?.board_name,
  }), [boardName?.data?.data?.responseData]);

  const avatarStyles = useMemo(() => (
    !hasImage(userData.userImage) ? {
      bgcolor: userData.profileColor?.background || "",
      color: userData.profileColor?.text,
    } : {}
  ), [userData.userImage, userData.profileColor]);

  const formattedDate = useMemo(() => (
    moment.utc(history?.at_time)
      .local()
      .format(isMobile ? "MMM D, YYYY [at] h:mm A" : "MMMM D, YYYY [at] h:mm A")
  ), [history?.at_time, isMobile]);

  const openBoard = useCallback(() => {
    navigate(`/board/${boardData.boardId}`);
  }, [navigate, boardData.boardId]);


  const handleCardClick = useCallback((event) => {
    const isModifierPressed = event.metaKey || event.ctrlKey || event.shiftKey;
    const url = `/feeds/${boardKey}/${boardKey}-${history?.card_id}?${searchParams.toString()}`;
    if (isModifierPressed) {
      window.open(url, "_blank");
      event.stopPropagation();
      return;
    }
    navigate(url);
  }, [updateSearchParams, history?.card_id]);


  if (!history) return null;

  const value = history?.response_object?.old_value;
  const newValue = history?.response_object?.new_value;
  let result;
  let newResult;
  
  if (history?.response_object?.field_type === 'checkbox') {
    try {
      const parsedValue = JSON.parse(value);
      result = Array.isArray(parsedValue) ? parsedValue.join(', ') : value;
    } catch (e) {
      result = value;
    }
    try {
      const parsedNewValue = JSON.parse(newValue);
      newResult = Array.isArray(parsedNewValue) ? parsedNewValue.join(', ') : newValue;
    } catch (e) {
      newResult = newValue;
    }
  } else {
    result = (Array.isArray(value) ? value.length > 0 : value) ? value : "None";
    newResult = newValue;
  }

  return (
    <Grid
      container
      spacing={2}
      sx={{
        width: isMobile
          ? "calc(100% - 10px) !important"
          : "calc(100% + 16px) !important",
      }}
      className="worklog-item d-flex justify-content-space-between"
    >
      <Grid
        item
        xs={isMobile ? 12 : 9}
        sx={{ paddingLeft: isMobile && "8px !important" }}
      >
        <div className="d-flex w-100">
          <Avatar
            // key={`user-avtar-${el.user_id}`}
            username={`${history?.response_object?.user_object?.username}`}
            user_image={history?.response_object?.user_object?.user_image}
            title={`${history?.response_object?.user_object?.username}`}
            className="user-avtar-dropdown user-avatar mr-8"
            style={avatarStyles}
          >
            {createAvtarName(userData.username)}
          </Avatar>
          <div className="w-100">
            <div className="d-flex justify-content-space-between ">
              <div className={"d-flex align-items-center"}>
                <div>
                  <Tooltip
                    title={boardData.boardName}
                  >
                    <a
                      className="board-anquor cursor-pointe underliner"
                      onClick={openBoard}
                    >
                      {boardData.boardKey?.toUpperCase()}
                    </a>
                  </Tooltip>
                  -
                  <a
                    className="board-anquor cursor-pointer mr-1 underline"
                    onClick={handleCardClick}>
                    {history?.card_id}:
                  </a>
                </div>
                <p className="worklog-title mr-2">
                  {userData.username}
                </p>
              </div>
            </div>
            <p
              className="worklog-worklog comment-content"
              dangerouslySetInnerHTML={{
                __html: history?.history_text,
              }}></p>
            {history?.response_object?.old_allocated_hours && <div className="d-flex align-items-center history-heading">
              <div className="old-status-box">
                <p className="old-status">{history?.response_object?.old_allocated_hours}</p>
              </div>
              <img className="arrow-img" src={arrow} alt="" />
              <div className="new-status-box">
                <p className="new-status">{history?.response_object?.updated_allcated_hours}</p>
              </div>
            </div>}

            {!hideDetails && (isDueDate ?
              <div className="d-flex align-items-center history-heading">
                <div>
                  <p>{result === 'None' ? 'None' : formateDateMMDDYY(result)}</p>
                </div>
                <img className="arrow-img" src={arrow} alt="" />
                <div>
                  <p>{formateDateMMDDYY(history?.response_object?.new_value) || "None"}</p>
                </div>
              </div>
              :
              (history?.response_object?.new_value || history?.response_object?.old_value) &&
              <div className="d-flex align-items-center history-heading">
                {history?.response_object?.old_value && <div >
                  <p dangerouslySetInnerHTML={{ __html: result }}></p>
                </div>}
                {history?.response_object?.old_value && history?.response_object?.new_value && <img className="arrow-img" src={arrow} alt="" />}
                <div>
                  <p dangerouslySetInnerHTML={{ __html: newResult }}></p>
                </div>
              </div>)
            }
          </div>
        </div>
      </Grid>
      <Grid
        item
        xs={isMobile ? 12 : 3}
        sx={{ paddingTop: isMobile && "0px !important" }}
      >
        <div className={"right-details d-flex"}>
          <p className="worklog-date-time comment-date comment">
            Updated on{" "}
          </p>
          <p className="worklog-date-time comment-date">
            {formattedDate}
          </p>
        </div>
      </Grid>
    </Grid>
  )
}

export default React.memo(CustomFields);
